import {
    SAILS_BNT_STORAGE,
    SAILS_PARAM_FLOW_TYPE,
    FLOW_DEVICES_FIRST,
    FLOW_SUBSCRIPTIONS_FIRST,
    BTX_BNT,
    SalesChannel,
} from '@vfde-sails/constants';
import {
    getSessionStorageItemJson,
    SailsBntStorage,
    setSessionStorageItemJson,
} from '@vfde-sails/storage';
import {
    TrackingFlowTypeWithSalesChannel,
    TRACKING_FLOWTYPE_STORAGE,
    getFlowType,
} from '@vfde-sails/tracking';

/**
 * Returns the flowType for tracking based on the existing `TRACKING_FLOWTYPE_STORAGE` storage value
 * or the `SAILS_PARAM_FLOW_TYPE` property of the SAILS BNT storage.
 */
export const getTrackingFlowType = (salesChannel: SalesChannel): TrackingFlowTypeWithSalesChannel => {
    // try to get trackingFlowType from sessionStorage first
    let flowType = getSessionStorageItemJson<TrackingFlowTypeWithSalesChannel>(TRACKING_FLOWTYPE_STORAGE);

    if (!flowType) {
        // flowType was not found in storage, so we need to generate it based on the flowType of the BNT storage
        const storage = getSessionStorageItemJson<SailsBntStorage>(SAILS_BNT_STORAGE);
        const isDevicesFirst = !storage || storage[SAILS_PARAM_FLOW_TYPE] === FLOW_DEVICES_FIRST;

        flowType = getFlowType(
            isDevicesFirst ? FLOW_DEVICES_FIRST : FLOW_SUBSCRIPTIONS_FIRST,
            salesChannel,
            BTX_BNT,
        );

        // store generated flowType in the storage
        setSessionStorageItemJson(TRACKING_FLOWTYPE_STORAGE, flowType);
    }

    return flowType;
};
